import { useState, useEffect } from "react";

const useGetHostname = () => {
    const [hostname, setHostname] = useState("");

    useEffect(() => {
        if (typeof window !== "undefined") {
            setHostname(window.location.hostname);
        }
    }, []);

    return hostname;
};

export default useGetHostname;
